import { TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutBackOfficeReasonCodeList } from "./autogen/AutogenLayoutBackOfficeReasonCodeList";

export class BackOfficeReasonCodeList extends AutogenLayoutBackOfficeReasonCodeList {
    private codeTypeMap = new Map<string, string>();

    override onLoad(): void {
        this.codeTypeMap.set("B", "Invoicing");
        this.codeTypeMap.set("S", "Settlement");
        this.codeTypeMap.set("A", "Accounts Payable");
        this.codeTypeMap.set("C", "Cash Receipts");
    }

    tableBackOfficeReasonCodeOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.data != null) {
            const modelRow = tableRow.data;

            const textboxCodeType = tableRow.findComponentById("textboxCodeType") as Textbox;
            const codeType = modelRow.getString("code_type", "");
            const displayCodeType: string[] = [];

            if (codeType != undefined && codeType.includes(textboxCodeType.valueDelimiter)) {
                const splitCodeType = codeType.split(textboxCodeType.valueDelimiter);
                const value = this.codeTypeMap.get("B");
                splitCodeType.forEach(type => {
                    displayCodeType.push(this.codeTypeMap.get(type));
                });
                textboxCodeType.text = displayCodeType.join(", ");

            }
        }
    }
}
